/**
 * File type normalization utilities for frontend
 * Maps UI display names to normalized backend types
 */

// Mapping from UI display names to normalized backend types
const UI_TO_NORMALIZED: Record<string, string> = {
  // Bank-related
  'Bank Statements': 'bank_statement',
  'Bank credit (deposit)': 'bank_credit',
  'Bank debit (withdrawal)': 'bank_debit',
  'Bank signature card': 'bank_signature_card',
  
  // Check-related
  'Check Images': 'check_image',
  'Check register': 'check_register',
  'Deposit image': 'deposit_image',
  
  // Financial statements
  'Financial statement - Balance sheet': 'financial_statement_balance_sheet',
  'Financial statement - Income statement': 'financial_statement_income',
  'Financial statement - Statement of cash flows': 'financial_statement_cash_flow',
  'Financial statement - Other': 'financial_statement_other',
  
  // Tax forms
  'IRS Tax form 1040': 'irs_tax_form_1040',
  'IRS Tax form 1065': 'irs_tax_form_1065',
  'IRS Tax form 1099': 'irs_tax_form_1099',
  'IRS Tax form 1120': 'irs_tax_form_1120',
  'IRS Tax form 1120S': 'irs_tax_form_1120s',
  'IRS Tax form 941': 'irs_tax_form_941',
  'IRS Tax form K-1': 'irs_tax_form_k1',
  'IRS Tax form Other': 'irs_tax_form_other',
  'IRS Tax form W2': 'irs_tax_form_w2',
  'IRS Tax form W4': 'irs_tax_form_w4',
  
  // Other common types
  'Appraisal': 'appraisal',
  'Correspondence': 'correspondence',
  'Credit card statement': 'credit_card_statement',
  'Deeds and titles': 'deeds_titles',
  'Depreciation schedule': 'depreciation_schedule',
  'Email': 'email',
  'Expense report': 'expense_report',
  'General ledger': 'general_ledger',
  'Investment account statement': 'investment_account_statement',
  'Invoice': 'invoice',
  'Lease agreement': 'lease_agreement',
  'Legal document': 'legal_document',
  'Loan application': 'loan_application',
  'Loan statement': 'loan_statement',
  'Note payable': 'note_payable',
  'Trial balance': 'trial_balance',
  'Wire transfer': 'wire_transfer',
  'Other': 'other',
};

// Reverse mapping for display
const NORMALIZED_TO_UI: Record<string, string> = {};
Object.entries(UI_TO_NORMALIZED).forEach(([ui, normalized]) => {
  NORMALIZED_TO_UI[normalized] = ui;
});

/**
 * Convert UI display name to normalized backend type
 */
export function normalizeFileType(uiDisplayName: string): string {
  return UI_TO_NORMALIZED[uiDisplayName] || 'other';
}

/**
 * Convert normalized backend type back to UI display name
 */
export function denormalizeFileType(normalizedType: string): string {
  return NORMALIZED_TO_UI[normalizedType] || normalizedType;
}

